module.exports = __webpack_public_path__ + "img/logo@3x.0af344a4.png";